/* tslint:disable */
import {
  Company
} from '../index';

declare var Object: any;
export interface ManufacturingWorkShiftInterface {
  "id"?: number;
  "name"?: string;
  "company_id"?: number;
  company?: Company;
}

export class ManufacturingWorkShift implements ManufacturingWorkShiftInterface {
  "id": number;
  "name": string;
  "company_id": number;
  company: Company;
  constructor(data?: ManufacturingWorkShiftInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ManufacturingWorkShift`.
   */
  public static getModelName() {
    return "ManufacturingWorkShift";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ManufacturingWorkShift for dynamic purposes.
  **/
  public static factory(data: ManufacturingWorkShiftInterface): ManufacturingWorkShift{
    return new ManufacturingWorkShift(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ManufacturingWorkShift',
      plural: 'ManufacturingWorkShifts',
      path: 'ManufacturingWorkShifts',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
      },
      relations: {
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ManufacturingWorkShift.ts